import { Card, CardActions, Typography, IconButton, Box } from "@mui/material";
import { CustomContentProps, SnackbarContent, useSnackbar } from "notistack";
import { forwardRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import CloseIcon from '@mui/icons-material/Close';

import './ImrReminder.scss';

export enum ImrReminderType {
  APP,
  FRA
}

interface ImrReminderProps extends CustomContentProps {
  type: ImrReminderType
}

const ImrReminder = forwardRef<HTMLDivElement, ImrReminderProps>(
  ({ id, ...props }, ref) => {
    const { t } = useTranslation();
    const { closeSnackbar } = useSnackbar();

    const handleDismiss = useCallback(() => {
      closeSnackbar(id);
    }, [id, closeSnackbar]);

    return (
      // @ts-ignore
      <SnackbarContent ref={ref} className='imr-reminder-snackbar'>
        <Card className='card'>
          <CardActions className='actions'>
            <Box>
              {
                props.type === ImrReminderType.APP ? (
                  <>
                    <Typography className='typography' sx={{ fontSize: '16px' }}>
                      {t('step_form.imr_reminder.email_1')}
                    </Typography>
                    <br/>
                    <Typography className='typography'>
                      {t('step_form.imr_reminder.email_2')}
                    </Typography>
                    <br/>
                    <Typography className='typography'>
                      {t('step_form.imr_reminder.email_3')}
                    </Typography>
                    <Typography className='typography'>
                      {t('step_form.imr_reminder.email_4')}
                    </Typography>
                    <Typography className='typography'>
                      {t('step_form.imr_reminder.email_5')}
                    </Typography>
                    <br/>
                    <Typography className='typography'>
                      {t('step_form.imr_reminder.email_6')}
                    </Typography>
                  </>
                ) : (
                  <>
                    <Typography className='typography' sx={{ fontSize: '16px' }}>
                      {t('step_form.imr_reminder.fragment_1')}
                    </Typography>
                  </>
                )
              }
            </Box>
            <IconButton onClick={handleDismiss}>
              <CloseIcon sx={{ color: '#fff' }} />
            </IconButton>
          </CardActions>
        </Card>
      </SnackbarContent> 
    )
  }
)

export default ImrReminder;
